import React from 'react'
const Login = React.lazy(() => import('_containers/login'))
const Apply = React.lazy(() => import('_containers/apply'))
const ApplyLogin = React.lazy(() => import('_containers/apply/apply-login'))
const CompanyBooking = React.lazy(() => import('_containers/apply/company-booking'))
const Activate = React.lazy(() => import('_containers/activate-account'))
const ShowAd = React.lazy(() => import('_containers/show-ad'))
const ShowSelection = React.lazy(() => import('_containers/show-selection'))
const Console = React.lazy(() => import('_containers/console'))

import * as url from '_routes/url-names'
import CommonRoute from '_routes/common-route'
import StartRoute from '_routes/start-route'

export default [
  {
    path: url.ROOT,
    element: <CommonRoute><StartRoute /></CommonRoute>
  },
  {
    path: url.ANSOK + url.REK_ID,
    element: <CommonRoute><Apply /></CommonRoute>
  },
  {
    path: url.ANSOK + url.REK_ID + url.LOGIN,
    element: <CommonRoute><ApplyLogin /></CommonRoute>
  },
  {
    path: url.ANSOK + url.REK_ID + url.BOKNING,
    element: <CommonRoute><CompanyBooking /></CommonRoute>
  },
  {
    path: url.LOGIN,
    element: <CommonRoute><Login /></CommonRoute>
  },
  {
    path: url.AKTIVERA + url.AKTIVERA_ID,
    element: <CommonRoute><Activate /></CommonRoute>
  },
  {
    path: url.ANNONS + url.ANNONSID,
    element: <CommonRoute><ShowAd /></CommonRoute>
  },
  {
    path: url.URVAL + url.ANNONSID,
    element: <CommonRoute><ShowSelection /></CommonRoute>
  },
  {
    path: url.CONSOLE,
    element: <CommonRoute><Console /></CommonRoute>
  }
]
